import { StarIcon as PhosphorStarIcon } from "@phosphor-icons/react/dist/ssr/Star";

import { createAppIcon } from "@/components/createAppIcon";

export const RatingIcon = /* @__PURE__ */ createAppIcon(PhosphorStarIcon);
